import Smartphones from 'Integrations/views/OpenPaymentsOnboardingView/containers/Smartphones'
import Tablets from 'Integrations/views/OpenPaymentsOnboardingView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const OpenPaymentsOnboardingView = getCurrentDeviceView(Smartphones, Tablets)

export default OpenPaymentsOnboardingView
